import { BlackClock } from '@assets/icons';
import SearchComponent from '@components/inputs/search/Search.component';
import { Colors } from '@constants/colors.constants';
import { CircularProgress, Stack, Step, Stepper, Typography, styled } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { auditsFollowUpService } from '@store/audits/audit-offer-followUp/audit-offer-followUp.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import { finalize } from 'rxjs';
import ActivityItem from './components/ActivityItem';
import ScrollingList from './components/ScrollingList';

const StyledStepper = styled(Stepper)({
  '& .MuiStepConnector-line': {
    borderLeftStyle: 'dashed',
    marginLeft: '8px',
    borderLeftWidth: '2px',
    borderLeftColor: 'rgba(0, 0, 0, 0.12)',
  },
});

const HistoryOffer = () => {
  const { t } = useTranslation();
  const { auditId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [{ auditsOfferActivities }] = useObservable(auditOfferFollowUpQuery.activities$);
  const [filters] = useObservable(auditOfferFollowUpQuery.filters$);

  useEffect(() => {
    if (auditId) {
      setLoading(true);
      auditsFollowUpService.getAuditsOfferActivities(auditId)
        .pipe(finalize(() => setLoading(false)))
        .subscribe({
          error: (err) => enqueueSnackbar(err.text, err.options),
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditId, filters]);

  return (
    <Stack p="20px" height={'100%'} spacing={4} >
      <Stack spacing={2} pr={'10px'}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <BlackClock style={{ height: 20, width: 20 }} />
          <Typography variant="h1" sx={{ color: Colors.black, fontWeight: 700, fontSize: '20px', textAlign: 'left' }}>
            {t('audits.auditOfferFollowUp.historyOffer.title')}
          </Typography>
        </Stack>
        <SearchComponent
          isCustom
          handleChange={(value) => auditsFollowUpService.setFilters('search')(value)}
          bgColor="#F4F6F8"
        />
      </Stack>
      {loading ? (
        <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
          <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
        </Stack>
      ) : (
        <>
          <ScrollingList height={'100%'}>
            <StyledStepper orientation="vertical">
              {auditsOfferActivities?.map((activity, idx) => (
                <Step key={`${activity.date}-${idx}}`}>
                  <ActivityItem item={activity} />
                </Step>
              ))}
            </StyledStepper>
          </ScrollingList>
          <Outlet />
        </>
      )}
    </Stack>
  );
};

export default HistoryOffer;